/* MUSE & MAKER - mm-piece-sync.js, 30 Sep 2026. THE HOMEPAGE ROW FOLLOWS THE FURNITURE PAGE.
   Clara, 30 Sep: "the attached band should exactly reflect the order of furniture in the
   products page - ideally, when i make a change in the products page, this band updates
   automatically." Liquid cannot read another template's blocks, so until today the row's
   order was a hand-made COPY of /pages/maker-section and went stale every time she dragged
   the grid in Customize. Now the row asks Shopify for the Furniture page's grid section
   (its grid section, found by id) as it loads and takes from it:
     - the ORDER of the cards (the grid's CSS order = its Card picture block order),
     - which cards are TWO PIECES WIDE,
     - each card's FRONT PICTURE,
     - which pieces are there at all (a piece on the grid the row lacks is copied in;
       a piece the grid no longer shows is hidden).
   What stays the row's own: the rounded-up price, its note, and the fabric pluses a
   row Card picture block carries - ALWAYS kept (5 Oct: while the row follows, the grid's
   picture is the only one Clara sees here, so it is the one her crosses are placed on).
   Loaded as a plain (blocking) script at the end of sections/mm-piece-row.liquid so it
   runs before the card scripts; it loads mm-piece-card.js, mm-piece-fit.js and
   mm-piece-sheet.js ITSELF, after the sync, so they bind to the final cards. If the
   fetch fails or takes over 3.5 s, the row shows its own server-rendered order and the
   scripts load anyway - nothing gets worse than before. The rail is faded out only while
   waiting, and only when JavaScript runs. */
(function(){
  var me=document.currentScript;
  var root=document.querySelector('#mmpi.mmpr');
  function loadScripts(){
    ['card','fit','sheet'].forEach(function(k){
      var u=me&&me.getAttribute('data-'+k);if(!u)return;
      var s=document.createElement('script');s.src=u;s.async=false;document.head.appendChild(s);
    });
  }
  if(!root||!me||me.getAttribute('data-follow')!=='true'){loadScripts();return;}
  var rail=root.querySelector('.mmpr__rail');if(!rail){loadScripts();return;}

  var done=false;
  rail.style.opacity='0';
  function finish(){
    if(done)return;done=true;
    rail.style.transition='opacity .35s ease';rail.style.opacity='';
    setTimeout(function(){rail.style.transition='';},400);
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',loadScripts);else loadScripts();
  }
  setTimeout(finish,3500);

  var base=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  /* The whole Furniture page is read, not ?section_id=: a section on a JSON page template is
     rendered as template--<number>__<id>, and that number changes whenever the theme is
     duplicated or published (30 Sep: ?section_id=mm_index was a 404). So the grid is found
     by the END of its id, which is the id Clara sees in the template and never changes. */
  var sec=me.getAttribute('data-section')||'mm_index';
  var url=base+(me.getAttribute('data-url')||'/pages/maker-section').replace(/^\//,'');

  function nameOf(c){var a=c.querySelector('.mmpi__nm');return a?a.textContent.replace(/\s+/g,' ').trim():'';}
  function pic(c){var i=c.querySelector('.mmpi__img');return i?(i.getAttribute('src')||'').split('?')[0].replace(/^https?:/,''):'';}
  function wide(c){return c.classList.contains('mmpi__card--wide');}
  var roundUp=me.getAttribute('data-round')==='true';
  var note=me.getAttribute('data-note')||'';

  /* a card copied in from the grid gets the row's price style and note */
  function rowMeta(c){
    var mt=c.querySelector('.mmpi__mt');if(!mt)return;
    var m=mt.textContent.match(/([^\d\s]*)\s*([\d,]+(?:\.\d+)?)/);if(!m)return;
    var n=parseFloat(m[2].replace(/,/g,''));if(roundUp)n=Math.ceil(n);
    var price=m[1]+n.toLocaleString('en-GB',{minimumFractionDigits:(n%1?2:0),maximumFractionDigits:2});
    var k=c.querySelectorAll('.mmpi__sz').length;
    mt.innerHTML='From '+price+(k>1?' &middot; '+k+' sizes':'')+(note?' &middot; '+note.replace(/</g,'&lt;'):'');
  }

  fetch(url,{credentials:'same-origin'}).then(function(r){if(!r.ok)throw 0;return r.text();}).then(function(html){
    if(done)return;
    var doc=new DOMParser().parseFromString(html,'text/html');
    var box=doc.querySelector('[id$="__'+sec+'"]')||doc.getElementById('shopify-section-'+sec);
    var gcards=box?[].slice.call(box.querySelectorAll('.mmpi__card')):[];
    if(!gcards.length)throw 0;
    gcards.sort(function(a,b){return (parseInt(a.style.order,10)||0)-(parseInt(b.style.order,10)||0);});

    var mine={};
    [].forEach.call(rail.querySelectorAll('.mmpi__card'),function(c){mine[nameOf(c)]=c;});
    var more=rail.querySelector('.mmpr__more');
    var used={};

    gcards.forEach(function(g,i){
      var nm=nameOf(g);if(!nm||used[nm])return;used[nm]=1;
      var c=mine[nm];
      if(!c){
        c=document.importNode(g,true);
        c.removeAttribute('data-g');
        rowMeta(c);
      }else{
        var samePic=pic(c)===pic(g);
        if(!samePic||wide(c)!==wide(g)){
          var gi=g.querySelector('.mmpi__img'),ci=c.querySelector('.mmpi__img'),ph=c.querySelector('.mmpi__ph');
          if(gi){
            var ni=document.importNode(gi,true);
            if(ci)ci.parentNode.replaceChild(ni,ci);
            else if(ph)ph.parentNode.replaceChild(ni,ph);
          }
        }
        c.classList.toggle('mmpi__card--wide',wide(g));
        c.hidden=false;
      }
      c.style.order=(i+1)*10;
      rail.insertBefore(c,more||null);
    });
    Object.keys(mine).forEach(function(k){if(!used[k])mine[k].hidden=true;});
    rail.scrollLeft=0;
    finish();
  }).catch(function(){finish();});
})();